import { ModifierKey } from '../types';
import { Base } from './base';
export class SelectionManager extends Base {
    get widgetOptions() {
        return this.options.selecting;
    }
    get rubberbandDisabled() {
        return (this.widgetOptions.enabled !== true ||
            this.widgetOptions.rubberband !== true);
    }
    get disabled() {
        return this.widgetOptions.enabled !== true;
    }
    get length() {
        return this.widget.length;
    }
    get cells() {
        return this.widget.cells;
    }
    init() {
        this.widget = this.graph.hook.createSelection();
        this.graph.on('blank:mousedown', ({ e }) => {
            if (!this.rubberbandDisabled &&
                ModifierKey.test(e, this.widgetOptions.modifiers) &&
                this.graph.hook.allowRubberband(e)) {
                this.startRubberband(e);
            }
            else {
                this.clean();
            }
        });
        this.graph.on('node:mouseup', ({ e, cell }) => {
            if (!this.disabled) {
                if (this.widgetOptions.multiple === false ||
                    (!e.ctrlKey && !e.metaKey)) {
                    this.clean();
                }
                this.select(cell);
            }
        });
        this.widget.on('box:mousedown', ({ cell, e }) => {
            if (!this.disabled) {
                if (this.widgetOptions.multiple !== false && (e.ctrlKey || e.metaKey)) {
                    this.unselect(cell);
                }
            }
        });
    }
    isEmpty() {
        return this.length <= 0;
    }
    isSelected(cell) {
        return this.widget.isSelected(cell);
    }
    select(cells, options = {}) {
        this.widget.select(cells, options);
        return this;
    }
    unselect(cells, options = {}) {
        this.widget.unselect(Array.isArray(cells) ? cells : [cells], options);
        return this;
    }
    clean() {
        this.widget.clean();
        return this;
    }
    enable() {
        if (this.disabled) {
            this.widgetOptions.enabled = true;
        }
        return this;
    }
    disable() {
        if (!this.disabled) {
            this.widgetOptions.enabled = false;
        }
        return this;
    }
    startRubberband(e) {
        if (!this.rubberbandDisabled) {
            this.widget.startSelecting(e);
        }
        return this;
    }
    enableRubberband() {
        if (this.rubberbandDisabled) {
            this.widgetOptions.rubberband = true;
            if (ModifierKey.equals(this.graph.options.scroller.modifiers, this.graph.options.selecting.modifiers)) {
                this.graph.scroller.disablePanning();
            }
        }
        return this;
    }
    disableRubberband() {
        if (!this.rubberbandDisabled) {
            this.widgetOptions.rubberband = false;
        }
        return this;
    }
    isMultiple() {
        return this.widgetOptions.multiple !== false;
    }
    enableMultiple() {
        this.widgetOptions.multiple = true;
        return this;
    }
    disableMultiple() {
        this.widgetOptions.multiple = false;
        return this;
    }
    setModifiers(modifiers) {
        this.widgetOptions.modifiers = modifiers;
        return this;
    }
    setContent(content) {
        this.widget.setContent(content);
        return this;
    }
    setFilter(filter) {
        this.widget.setFilter(filter);
        return this;
    }
}
//# sourceMappingURL=selection.js.map